import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('ErrorBoundary fanget fejl:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-background flex items-center justify-center px-4">
          <div className="max-w-md text-center space-y-4">
            <h1 className="text-2xl font-serif text-gray-900">
              Noget gik galt
            </h1>
            <p className="text-gray-600">
              Der opstod en uventet fejl. Prøv at genindlæse siden.
            </p>
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="px-6 py-3 rounded-xl bg-brand text-white font-semibold
                hover:bg-brand-600 transition-colors
                focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2"
            >
              Prøv igen
            </button>
            <p className="text-sm text-gray-400">
              Hvis fejlen fortsætter, kontakt os på{' '}
              <a href="mailto:morten@droemmevillaen.dk" className="underline hover:text-brand transition-colors">
                morten@droemmevillaen.dk
              </a>
            </p>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
